<template>
	<div class="order-message" :style="`background-color: ${success ? '#6fc387' : '#ed6464'}`">
		<p v-if="success">
			Gracias por su compra, el pago fue procesado,
			su pedido fue realizado con exito.
		</p>
		<p v-else-if="!!errors[actionCode]">
			{{ errors[actionCode].message }}
		</p>
		<p v-else>
			Lo sentimos, el pago no pudo ser procesado,
			su pedido ha sido cancelado.
		</p>
		<button type="button" @click="$emit('close-message')">
			<span>x</span>
		</button>
	</div>
</template>

<script>
	function data() {
		return {
			errors: {
				180: {
					descriptionHelp: 'Operación Denegada. Tarjeta inválida.',
					message: 'Operación Denegada. Tarjeta Inválida. Contactar con entidad emisora de su tarjeta.',
				},
				670: {
					descriptionHelp: 'Operación Denegada. Módulo antifraude.',
					message: 'Operación Denegada. Contactar con el comercio.',
				},
			},
		};
	}

	export default {
		name: 'order-message',
		data,
		props: {
			actionCode: [Number, String],
			success: {
				default: false,
				type: Boolean,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.order-message {
		color: color(white);
		font-family: font(avenirDemi);
		font-size: size(large);
		height: 56px;
		left: 0;
		letter-spacing: 0;
		line-height: 56px;
		padding: 0px 76px 0px 46px;
		position: absolute;
		right: 0;
		top: 0px;
		width: 100%;

		p {
			margin: 0px;
		}

		button {
			background-color: transparent;
			border: 0px;
			bottom: 0px;
			color: color(white);
			font-family: font(avenirDemi);
			font-size: size(large);
			height: auto;
			margin: auto;
			position: absolute;
			right: 46px;
			top: 0px;
		}
	}
</style>



// WEBPACK FOOTER //
// order-message.vue?1877a3b3